import Orchestrator from "../Orchestrator.js";
import { device } from "./device.js";

export default class Sizes {
    constructor() {
        this.orc = new Orchestrator();
        this.emitter = this.orc.emitter;
        // cap to 1.5 for performance improvement
        this.maxPixelRatio = Math.min(device.maxPixelRatio, 1.5);

        // Setup
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.pixelRatio = Math.min(window.devicePixelRatio, this.maxPixelRatio);

        // Resize event
        window.addEventListener("resize", () => {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            this.pixelRatio = Math.min(
                window.devicePixelRatio,
                this.maxPixelRatio,
            );

            this.emitter.emit("resize");
        });
    }
}
